import apiClient from '@/shared/api/client';
import { ApiResponse } from '@/shared/api/types';
import { AuthUser } from '@/shared/context/AuthContext';

interface MagicLinkRequest {
  email: string;
}
interface MagicLinkResponse {
  message: string;
}

interface AuthTokens {
  access_token: string;
  refresh_token: string;
  user: AuthUser;
}

interface RefreshRequest {
  refresh_token: string;
  practiceId?: string;
}

interface PracticeInfo {
  id: string;
  name: string;
  role: string;
}
interface SwitchPracticeRequest {
  practiceId: string;
  refreshToken: string;
}

export const authApi = {
  sendMagicLink: async (email: string): Promise<ApiResponse<MagicLinkResponse>> => {
    const response = await apiClient.post<ApiResponse<MagicLinkResponse>>('/auth/magic-link', {
      email,
    } satisfies MagicLinkRequest);
    return response.data;
  },

  verifyToken: async (token: string): Promise<ApiResponse<AuthTokens>> => {
    const response = await apiClient.get<ApiResponse<AuthTokens>>(
      `/auth/verify?token=${token}` satisfies string,
    );
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<ApiResponse<AuthTokens>> => {
    const response = await apiClient.post<ApiResponse<AuthTokens>>('/auth/refresh', {
      refresh_token: refreshToken,
    } satisfies RefreshRequest);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
  },

  getUserPractices: async (): Promise<ApiResponse<PracticeInfo[]>> => {
    const response = await apiClient.get<ApiResponse<PracticeInfo[]>>('/auth/practices');
    return response.data;
  },

  switchPractice: async (
    practiceId: string,
    refreshToken: string,
  ): Promise<ApiResponse<AuthTokens>> => {
    const response = await apiClient.post<ApiResponse<AuthTokens>>('/auth/switch-practice', {
      practiceId,
      refreshToken,
    } satisfies SwitchPracticeRequest);
    return response.data;
  },
};
